// extracted by mini-css-extract-plugin
module.exports = {"container":"CommingSoon_container__XfaWr","title":"CommingSoon_title__1zgw3","icon_container":"CommingSoon_icon_container__2fJul","icon":"CommingSoon_icon__xzSK5"};